export const PUSH_NOTIFICATIONS_ANIMATION_DURATION = 300;
export const PUSH_NOTIFICATIONS_VISIBILITY_DURATION = 5000;
